module.exports = __webpack_public_path__ + "img/sam-shooter.67c7665e.jpg";